import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoutes = () => {
    const { isLoggedIn } = useAuth();
    if (!isLoggedIn()) {
        return <Navigate to="/" />;
    }
    return <Outlet />;
};

export default PrivateRoutes;
